import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import config from 'config'
import { selectCurrentUser } from 'ducks/currentUser'
import { Help } from '@groovehq/internal-design-system/lib/assets/icons'
import GlobalNavItem from '@groovehq/internal-design-system/lib/components/GlobalNav/GlobalNavItem/GlobalNavItem'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import ProgressCircle from '@groovehq/internal-design-system/lib/components/ProgressCircle/ProgressCircle'
import HelpMenu from './HelpMenu'
import { styles } from './styles'
import { useFrillWidget } from './hooks'

const FRILL_WIDGETS = config.frillWidgets
const SHOW_FRILL_ANNOUNCEMENTS = config.showFrillAnnoucements
const menuOffset = [-16, 4]

const HelpItem = ({ isLeftSidebarCollapsed }) => {
  const [announcementCount, setAnnouncementCount] = useState()
  const currentUser = useSelector(selectCurrentUser)
  const handleClickAnnoucementsLauncher = useFrillWidget(
    SHOW_FRILL_ANNOUNCEMENTS ? FRILL_WIDGETS.announcements.key : null,
    currentUser,
    setAnnouncementCount
  )

  const handleClickIdeasLauncher = useFrillWidget(
    FRILL_WIDGETS.ideas.key,
    currentUser
  )

  return (
    <Dropdown
      overlay={
        <HelpMenu
          setAnnouncementCount={setAnnouncementCount}
          announcementCount={announcementCount}
          onClickAnnoucementsLauncher={handleClickAnnoucementsLauncher}
          onClickIdeasLauncher={handleClickIdeasLauncher}
          showAnnoucementItem={SHOW_FRILL_ANNOUNCEMENTS}
        />
      }
      position="right-end"
      strategy="fixed"
      offset={menuOffset}
      autoHeight
      menuItemIconHidden
    >
      <div className="grui position-relative">
        <GlobalNavItem
          title="Get help"
          icon={<Help />}
          isLeftSidebarCollapsed={isLeftSidebarCollapsed}
        />
        {announcementCount > 0 && (
          <ProgressCircle css={styles.progressCircle} />
        )}
      </div>
    </Dropdown>
  )
}

export default HelpItem
